import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="913"
      height="428.58"
      data-name="Layer 1"
      viewBox="0 0 913 441.869"
      style={{maxWidth: '100%'}}
    >
      <path
        fill="#fff"
        d="M267.718 582.34h686.644V234.73H267.718z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#e5e5e5"
        d="M960.026 588.005H262.054v-358.94h697.972zm-686.644-11.328h675.316V240.394H273.382z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#536dfe"
        d="M444.691 79.203L444.691 197.186 273.183 197.186 241.498 235.203 245.116 197.186 229.699 197.186 229.699 79.203 444.691 79.203z"
      ></path>
      <path
        fill="#f0f0f0"
        d="M548.482 86.203L548.482 161.849 658.445 161.849 678.76 186.223 676.441 161.849 686.325 161.849 686.325 86.203 548.482 86.203z"
      ></path>
      <path
        fill="#ffb7b7"
        d="M94.66 430.711L104.581 430.711 109.301 392.445 94.659 392.445 94.66 430.711z"
      ></path>
      <path
        fill="#2f2e41"
        d="M235.63 656.538h19.538a12.452 12.452 0 0112.451 12.45v.405H235.63z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#ffb7b7"
        d="M213.852 430.385L223.486 428.014 218.925 389.729 204.707 393.228 213.852 430.385z"
      ></path>
      <path
        fill="#2f2e41"
        d="M354.121 656.91l18.972-4.669a12.452 12.452 0 0115.066 9.115l.097.393-31.063 7.645zM232.06 650.653l2.06-10.545s3.794-40.713 31.02-81.345l8.861-44.14s-2.632-33.41 22.77-51.495l7.831-5.394 27.458 1.573 6.341 34.719 12.777 82.147s3.298.31 4.534 9.809a28.568 28.568 0 014.328 13.242s6.54 18.04 8.291 31.321l-.206 12.997-13.808 7.356-28.779-81.39-20.584-45.501s-9.907 32.058-25.082 59.523c0 0-20.785 44.987-24.937 54.126l-4.534 14.959z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <circle cx="180.363" cy="139.182" r="19.625" fill="#ffb7b7"></circle>
      <circle cx="180.363" cy="139.182" r="19.625" fill="#ffb8b8"></circle>
      <path
        fill="#3f3d56"
        d="M296.829 463.338l6.478-16.183a72.785 72.785 0 01.8-45.382l1.24-1.021c10.799-8.893 20.276-7.274 29.071 3.604a24.316 24.316 0 004.921 4.64c3.88 2.722 10.033 17.507 1.908 26.174l-6.5 37.918c.684 20.935-14.507 13.052-37.918-9.75z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#ffb7b7"
        d="M389.723 441.328a7.185 7.185 0 00-10.738 2.47l-16.37-1.274-3.2 9.76 23.143 1.474a7.224 7.224 0 007.165-12.43z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#ccc"
        d="M374.05 457.159l-46.646-8.71-15.172-25.436a10.834 10.834 0 0120.382-7.351l7.116 19.678 36.89 6.106z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <circle cx="145.381" cy="116.055" r="18.828" fill="#2f2e41"></circle>
      <path
        fill="#2f2e41"
        d="M272.64 360.712a18.83 18.83 0 0029.076-9.886 18.83 18.83 0 11-36.728-7.722 18.822 18.822 0 007.653 17.608z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#2f2e41"
        d="M346.945 360.733c-3.287-5.885-4.545-8.343-8.783-11.921-3.748-3.165-8.358-4.094-12.076-1.095a22.267 22.267 0 1013.436 20.439 22.45 22.45 0 00-.152-2.518c3.232-.454 4.343-4.451 7.575-4.905z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#a0616a"
        d="M925.749 501.591a8.893 8.893 0 0110.858-8.25l11.76-16.575 11.816 4.69-16.938 23.173a8.942 8.942 0 01-17.496-3.038z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#3f3d56"
        d="M938.65 487.337l20.91-35.168-8.519-22.718 11.603-30.942.428.183c.28.12 6.874 3.063 7.85 13.598l13.335 41.907-35.587 46.166z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#a0616a"
        d="M825.085 358.048a8.893 8.893 0 017.386 11.463l15.615 13.007-5.59 11.418-21.793-18.679a8.942 8.942 0 014.382-17.21z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#3f3d56"
        d="M838.298 372.013l33.447 23.567 23.308-6.738 29.953 13.96-.216.413c-.142.27-3.585 6.616-14.165 6.776l-42.811 10.054-43.277-39.05z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#a0616a"
        d="M755.999 429.531L744.371 429.531 738.84 384.681 756.001 384.682 755.999 429.531z"
      ></path>
      <path
        fill="#2f2e41"
        d="M736.066 426.208h22.424v14.12h-36.543a14.12 14.12 0 0114.119-14.12z"
      ></path>
      <path
        fill="#a0616a"
        d="M802.472 429.531L790.844 429.531 785.313 384.681 802.474 384.682 802.472 429.531z"
      ></path>
      <path
        fill="#2f2e41"
        d="M782.539 426.208h22.424v14.12H768.42a14.12 14.12 0 0114.119-14.12z"
      ></path>
      <path
        fill="#2f2e41"
        d="M806.607 265.827L805.659 332.217 804.71 419.472 783.845 417.575 773.412 297.125 760.134 417.575 738.593 417.575 736.423 296.176 744.011 269.62 806.607 265.827z"
      ></path>
      <path
        fill="#3f3d56"
        d="M885.431 499.091l-3.179-.137 14.765-81.337-6.045-24.584a5.38 5.38 0 013.334-6.32l10.877-4.08 3.843-10.567 30.319 3.267.746 8.259c3.285 1.054 30.34 10.064 28.474 20.33-1.843 10.134-12.722 42.016-13.274 43.632l-1.905 45.722-.235.117c-.282.141-21.18 10.416-43.883 10.415a57.723 57.723 0 01-23.837-4.717z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <circle cx="779.497" cy="115.941" r="21.83" fill="#a0616a"></circle>
      <path
        fill="#2f2e41"
        d="M940.68 366.138c-4.16 4.432-11.887 2.053-12.429-4.001a7.314 7.314 0 01.01-1.413c.28-2.682 1.828-5.116 1.457-7.948a4.168 4.168 0 00-.763-1.951c-3.315-4.44-11.097 1.986-14.226-2.033-1.918-2.464.337-6.344-1.135-9.098-1.943-3.635-7.698-1.842-11.308-3.833-4.015-2.215-3.775-8.376-1.132-12.124 3.224-4.57 8.876-7.009 14.458-7.36s11.125 1.157 16.336 3.188c5.921 2.308 11.792 5.497 15.436 10.703 4.431 6.331 4.857 14.843 2.641 22.246-1.348 4.504-5.948 10.005-9.346 13.624z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#ffb8b8"
        d="M560.665 423.5L563.908 415.158 533.276 398.679 528.489 410.991 560.665 423.5z"
      ></path>
      <path
        fill="#2f2e41"
        d="M721.54 630.804a11.227 11.227 0 00-14.538 6.4l-2.188 5.623-3.373 8.68-.824 2.129 10.809 4.204 10.455-26.9zM701.442 636.512l-1.41 3.74-3.52 9.336-.085.233c-8.968 1.153-18.8-1.106-27.893-4.616a113.381 113.381 0 01-10.676-4.764c-5.143-2.598-9.747-5.34-13.42-7.686-5.531-3.55-8.951-6.215-8.951-6.215s-.904.816-2.538 2.216a279.313 279.313 0 01-10.128 8.25q-2.538 1.985-5.45 4.153c-14.309 10.614-32.673-17.707-32.673-17.707s5.165-3.288 6.514-3.927c4.345-2.055 14.552-6.905 23.357-11.216 4.537-2.224 8.696-4.309 11.489-5.79 9.889-5.266 22.181 4.697 22.181 4.697z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        d="M701.442 636.512l-1.41 3.74-3.52 9.336-.085.233c-8.968 1.153-18.8-1.106-27.893-4.616a113.381 113.381 0 01-10.676-4.764c-5.143-2.598-9.747-5.34-13.42-7.686-5.531-3.55-8.951-6.215-8.951-6.215s-.904.816-2.538 2.216a279.313 279.313 0 01-10.128 8.25q-2.538 1.985-5.45 4.153c-14.309 10.614-32.673-17.707-32.673-17.707s5.165-3.288 6.514-3.927c4.345-2.055 14.552-6.905 23.357-11.216 4.537-2.224 8.696-4.309 11.489-5.79 9.889-5.266 22.181 4.697 22.181 4.697z"
        opacity="0.14"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#2f2e41"
        d="M558.313 557.996H515.97a3.289 3.289 0 01-3.285-3.285v-18.25a24.456 24.456 0 1148.912 0v18.25a3.289 3.289 0 01-3.285 3.285z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#ffb8b8"
        d="M598.58 580.92a6.845 6.845 0 00-5.246 9.092l-11.514 10.59 4.729 8.566 16.05-15.183a6.883 6.883 0 00-4.02-13.065z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#536dfe"
        d="M563.935 629.067q-.78 0-1.562-.067a18.396 18.396 0 01-14.818-9.896L529.11 583.6a10.187 10.187 0 0117.616-10.195l17.017 38.183 23.156-18.814 13.408 5.219-22.643 24.997a18.605 18.605 0 01-13.728 6.076z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#ffb8b8"
        d="M558.077 435.233L561.951 427.165 532.676 408.381 526.958 420.289 558.077 435.233z"
      ></path>
      <path
        fill="#2f2e41"
        d="M720.574 643.936a11.227 11.227 0 00-14.988 5.264l-2.613 5.438-4.03 8.396-.985 2.058 10.453 5.023 12.491-26.018zM700.096 648.083l-1.693 3.62-4.227 9.038-.102.227c-9.03.46-18.66-2.548-27.457-6.746a113.38 113.38 0 01-10.278-5.57c-4.928-2.986-9.308-6.074-12.79-8.694-5.242-3.965-8.447-6.885-8.447-6.885s-.964.745-2.701 2.015a279.244 279.244 0 01-10.732 7.447q-2.682 1.784-5.752 3.723c-15.083 9.483-36.53 21.032-54.775 23.47-32.04 4.285-24.5-38.472-24.5-38.472l25.5-13.243 10.827 2.197 12.053 2.438 4.27.87s.81-.307 2.205-.84c4.49-1.716 15.039-5.768 24.15-9.389 4.694-1.868 9-3.628 11.9-4.89 10.263-4.49 21.754 6.387 21.754 6.387z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#ffb8b8"
        d="M489.981 670.749a6.845 6.845 0 004.769-9.351l10.95-11.17-5.165-8.311-15.243 15.992a6.883 6.883 0 004.69 12.84z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <circle cx="399.637" cy="312.673" r="17.073" fill="#ffb8b8"></circle>
      <path
        fill="#536dfe"
        d="M520.926 589.13l14.872 42.163-.09.148c-2.068 3.42-2.744 6.178-1.954 7.977a3.476 3.476 0 002.203 1.9l35.194-24.6-1.232-9.858.069-.11c3.401-5.443 4.503-10.373 3.274-14.65a14.14 14.14 0 00-6.713-8.097l-.123-.096-17.553-21.365-23.465 4.17z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#536dfe"
        d="M498.31 663.137l-9.964-12.262 24.018-39.648 11.198-34.612.347.112-.347-.112a13.905 13.905 0 1124.794 11.999L527.8 619.413z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#2f2e41"
        d="M567.384 538.285h-25.891l-.266-3.717-1.327 3.717h-3.987l-.526-7.367-2.631 7.367h-7.714v-.365a19.368 19.368 0 0119.346-19.346h3.65a19.368 19.368 0 0119.346 19.346z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#2f2e41"
        d="M541.28 561.403a3.356 3.356 0 01-.58-.051l-18.96-3.345v-31.333h20.87l-.516.602c-7.189 8.384-1.773 21.979 2.095 29.336a3.237 3.237 0 01-.257 3.436 3.272 3.272 0 01-2.651 1.355z"
        transform="translate(-143.5 -229.066)"
      ></path>
      <path
        fill="#f0f0f0"
        d="M681.028 276.203L681.028 320.344 485.481 320.344 457.244 354.223 460.469 320.344 446.73 320.344 446.73 276.203 681.028 276.203z"
      ></path>
      <circle cx="528.028" cy="298.203" r="8" fill="#fff"></circle>
      <circle cx="501.028" cy="298.203" r="8" fill="#fff"></circle>
      <circle cx="474.028" cy="298.203" r="8" fill="#fff"></circle>
      <path
        fill="#cacaca"
        d="M1055.5 670.269h-911a1 1 0 010-2h911a1 1 0 010 2z"
        transform="translate(-143.5 -229.066)"
      ></path>
    </svg>
  );
}

export default Icon;
